export const enum CipherModel{
    // SERECT_KEY = "FbkbPk+rYI4/OylCWaaAfWNF3qIqtevAblNx5FzIh6s=",
    SERECT_KEY = "qpydp28JC53Xi6wdVodg/4t2mPWGp/8zIHXjb/8M",
    SERECT_KEY_SIZE =  32,
    TAG_SIZE = 128,
    CIPHER_NAME = "AES-GCM",
    // HASH_KEY = "4025eaa19d53bbfde6839835449624b43618ef69aff1249ead0d6f79a69b8ae9b82b1631ebadb75882c60db5b75e74ef638129dc95c085a0b08d14f686bc5e4e64a341d47725e82715dfa55dc596b81a0dad5d6b5786205c87359a18350d0a6d3d7dde77193827b884ea6502240b2e4e773b0759535c99bb2d6fff3aff115769",
    HASH_KEY = "a24fe29328dc0e680b64eec70b5e794ed4cf57855d19817606a1ebe7e995796b",
    HASH_NAME = "HMAC",
    HASH_TYPE = "SHA-256"
}